// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"hW","productsContainer":"iW","searchVerticalReco":"jW","heading":"kW"};